export const canSubmitMailboxPassword = (password) => String(password || "").length >= 8;

export const buildMailboxConfigurationPayload = (password) => ({
    password: String(password || ""),
});
